import React from "react";
import classes from "./CategorySection.module.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CategorySection = ({ categories }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    // <section className={classes.games_category_section}>
    <div className={classes.games_grid_container}>
      {categories.map((item, index) => {
        // if (index > 0 && item?.id > 0) {
        if (item.category_type === "html") {
          return (
            <div
              align="center"
              key={index}
              className={
                classes.containerImg +
                " " +
                `${classes.game_grid_item} ${
                  index === 2 ? classes.featured : ""
                }`
              }
              onClick={() =>
                navigate("/category", {
                  state: {
                    category_id: item?.id,
                  },
                })
              }
            >
              <div className={classes.game_grid_overlay}>
                <span>{t(item.category_name)}</span>
              </div>
              <img
                src={item.category_img}
                loading="lazy"
                alt={t(item.category_name)}
                className={classes.game_grid_item_image}
              />
            </div>
          );
        }
      })}
    </div>
    // </section>
  );
};

export default CategorySection;
